import { render, staticRenderFns } from "./step_1.3.vue?vue&type=template&id=43828a7a"
import script from "./step_1.3.vue?vue&type=script&lang=js"
export * from "./step_1.3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports